import { getActivePinia } from 'pinia'

// This is workaround for useRoute in store.
// https://github.com/vuejs/pinia/issues/1784#issuecomment-1426770383
// Latest pinia version has this feature.
// But we can't use it now because of the vue version.
// Do not use global router in store. Use these methods.

export function useRouter() {
  // @ts-ignore
  // eslint-disable-next-line no-underscore-dangle
  return getActivePinia()?._a.config.globalProperties.$router!
}

export function useRoute() {
  // @ts-ignore
  // eslint-disable-next-line no-underscore-dangle
  return getActivePinia()?._a.config.globalProperties.$route!
}
